import PropTypes from 'prop-types';
import React from 'react';
import T from 'components/T';
import { i18n } from '@international/mastodon-i18n';
import Panel from '../../../Panels';
import Record from '../Record/Employment';
import withNonCanceledSearch from './WithNonCanceledSearch';

// Pairs each record with its own job-application row. Canceled records never render, so they're skipped here too. employer.id is confirmed unique per record even on a rehire (customer!11724 comment thread — two stints at the same employer get two distinct CandidateEmployer ids), so a plain find is enough; no consume-once bookkeeping needed.
export const matchCustomerProvidedEmployers = (
  records,
  customerProvidedEmployers,
) =>
  records.map(record => {
    if (record.status === 'canceled') return null;
    return (
      (customerProvidedEmployers || []).find(
        customerProvided =>
          customerProvided.candidateEmployerResourceId === record.employer.id,
      ) || null
    );
  });

const EmploymentVerification = ({ search }) => {
  const customerProvidedMatches = matchCustomerProvidedEmployers(
    search.records,
    search.customerProvidedEmployers,
  );
  return (
    <Panel
      title={i18n.getStr('components.employment.title')}
      status={search.status}
    >
      {search.records.length === 0 && (
        <span>
          <T value='components.employment.noEmploymentHistory' />
        </span>
      )}
      {search.records.length > 0 &&
        search.records.map((record, i) => (
          <div className='mb-4' key={`div-${i + 1}`}>
            <Record
              record={record}
              customerProvided={customerProvidedMatches[i]}
            />
            {i < search.records.length - 1 && <hr />}
          </div>
        ))}
    </Panel>
  );
};
EmploymentVerification.propTypes = {
  search: PropTypes.object,
};

EmploymentVerification.defaultProps = {
  search: null,
};

export default withNonCanceledSearch(EmploymentVerification);
